import React from 'react';
import { Button, Text, Tooltip } from 'rizzui';
import { PiListNumbersDuotone } from 'react-icons/pi';
import { ActivityAuditChange, ActivityAuditEntryBase } from '../../type/entities/activity-audit-type';

export const formatActivityValue = (value: any) => {
    if (value === null || value === undefined || value === '') return 'Sin valor';
    if (typeof value === 'object' && 'display' in value) {
        return value.display === null || value.display === undefined || value.display === ''
            ? 'Sin valor'
            : String(value.display);
    }
    return String(value);
};

export const formatActivityDate = (date?: any) => {
    if (!date) return 'N/A';
    const value = typeof date === 'object' && 'date' in date ? date.date : date;
    return new Date(value).toLocaleString('es-ES');
};

export const renderActivityChangesSummary = (
    changes: ActivityAuditChange[] | null | undefined,
    onOpen: (changes: ActivityAuditChange[]) => void
) => {
    if (!changes || changes.length === 0) {
        return <Text className="text-sm text-gray-500">Sin detalle estructurado</Text>;
    }

    return (
        <div className="flex items-center gap-2">
            <Text className="text-sm text-gray-700">
                {changes.length} cambio{changes.length !== 1 ? 's' : ''}
            </Text>
            <Button
                size="sm"
                variant="outline"
                className="h-8 px-3"
                onClick={() => onOpen(changes)}
            >
                <PiListNumbersDuotone className="mr-1.5 h-4 w-4" />
                Ver
            </Button>
        </div>
    );
};

export const ActivityChangesModalContent: React.FC<{ changes?: ActivityAuditChange[] | null }> = ({ changes }) => {
    if (!changes || changes.length === 0) {
        return <Text className="text-sm text-gray-500">Sin detalle estructurado</Text>;
    }

    return (
        <div className="space-y-3">
            {changes.map((change, index) => (
                <div
                    key={`${change.field}-${index}`}
                    className="rounded-md border border-gray-200 bg-white p-4"
                >
                    <div className="mb-3 text-sm font-semibold text-gray-900">{change.label}</div>
                    <div className="grid gap-3 md:grid-cols-2">
                        <div className="rounded-md border border-red-200 bg-red-50 p-3">
                            <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-red-800">Valor antiguo</div>
                            <div className="break-words text-sm font-medium text-red-900">
                                {formatActivityValue(change.oldValue)}
                            </div>
                        </div>
                        <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3">
                            <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-emerald-800">Valor nuevo</div>
                            <div className="break-words text-sm font-medium text-emerald-900">
                                {formatActivityValue(change.newValue)}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export const renderActivityIpAddress = (activity: ActivityAuditEntryBase) => {
    const ipAddress = activity.ipAddress || 'N/A';
    const meta = [activity.requestMethod, activity.requestRoute].filter(Boolean).join(' ');

    if (!activity.userAgent && !meta) {
        return <Text>{ipAddress}</Text>;
    }

    return (
        <Tooltip
            size="md"
            content={
                <div className="max-w-[360px] text-sm">
                    <div>IP: {ipAddress}</div>
                    {meta && <div>{meta}</div>}
                    {activity.userAgent && <div className="break-all">{activity.userAgent}</div>}
                </div>
            }
            placement="top"
            color="invert"
        >
            <div className="text-sm">{ipAddress}</div>
        </Tooltip>
    );
};
